/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Materiality } from './Materiality';
import { MaterialityFromJSON, MaterialityFromJSONTyped, MaterialityToJSON } from './Materiality';
import type { EuAiActRiskClass } from './EuAiActRiskClass';
import { EuAiActRiskClassFromJSON, EuAiActRiskClassFromJSONTyped, EuAiActRiskClassToJSON } from './EuAiActRiskClass';

/**
 *
 * @export
 * @interface DashboardUseCaseCounts
 */
export interface DashboardUseCaseCounts {
  /**
   * Readiness counts for each lifecycle stage.
   * @type {{ [key: string]: number; }}
   * @memberof DashboardUseCaseCounts
   */
  readiness: { [key: string]: number };
  /**
   *
   * @type {EuAiActRiskClass}
   * @memberof DashboardUseCaseCounts
   */
  euAiActRiskClass: EuAiActRiskClass;
  /**
   *
   * @type {Materiality}
   * @memberof DashboardUseCaseCounts
   */
  materiality: Materiality;
  /**
   * Counts of risk assessments by label.
   * @type {{ [key: string]: number; }}
   * @memberof DashboardUseCaseCounts
   */
  riskAssessment: { [key: string]: number };
}

/**
 * Check if a given object implements the DashboardUseCaseCounts interface.
 */
export function instanceOfDashboardUseCaseCounts(value: object): value is DashboardUseCaseCounts {
  if (!('readiness' in value) || value['readiness'] === undefined) return false;
  if (!('euAiActRiskClass' in value) || value['euAiActRiskClass'] === undefined) return false;
  if (!('materiality' in value) || value['materiality'] === undefined) return false;
  if (!('riskAssessment' in value) || value['riskAssessment'] === undefined) return false;
  return true;
}

export function DashboardUseCaseCountsFromJSON(json: any): DashboardUseCaseCounts {
  return DashboardUseCaseCountsFromJSONTyped(json, false);
}

export function DashboardUseCaseCountsFromJSONTyped(json: any, ignoreDiscriminator: boolean): DashboardUseCaseCounts {
  if (json == null) {
    return json;
  }
  return {
    readiness: json['readiness'],
    euAiActRiskClass: EuAiActRiskClassFromJSON(json['eu_ai_act_risk_class']),
    materiality: MaterialityFromJSON(json['materiality']),
    riskAssessment: json['risk_assessment'],
  };
}

export function DashboardUseCaseCountsToJSON(value?: DashboardUseCaseCounts | null): any {
  if (value == null) {
    return value;
  }
  return {
    readiness: value['readiness'],
    eu_ai_act_risk_class: EuAiActRiskClassToJSON(value['euAiActRiskClass']),
    materiality: MaterialityToJSON(value['materiality']),
    risk_assessment: value['riskAssessment'],
  };
}
